<template>
  <footer class="footer">
    <p>&copy; Sergio Penagos All rights reserved.</p>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "FooterFile",
});
</script>
